/* eslint-env browser */
/* eslint-env jquery */

((window) => {
  const doc = window.document;
  const googlePlaces = window.google.maps.places;
  const ls = window.localStorage;

  const RECENT_SEARCH_LABEL = 'recentSearch';
  const RECENT_ADDRESS_LABEL = 'recentAddress';
  const MAX_RECENT_SEARCHES = 5;
  const MAX_RECENT_ADDRESSES = 5;

  class SearchWidget {
    constructor(form) {
      if (!form) {
        throw new Error('Search form must exist.');
      }

      this.optionForm = form;
    }

    init() {
      this.searchInput = this.optionForm.elements.q;
      this.searchCategoryIcon = doc.getElementById('selected-search-category-icon');
      this.searchCategory = this.optionForm.elements.cuisine;
      this.searchAddress = this.optionForm.elements.address;

      this.addressAutocomplete = this.optionForm.querySelector('.fake-search-address-item');
      this.addressAutocompleteContainer = this.optionForm.querySelector('.address-autocomplete-container');

      this.recentSearchesContainer = this.optionForm.querySelector('.recent-searches-container');
      this.recentAddressesContainer = this.optionForm.querySelector('.recent-addresses-container');

      this.autocompleteService = new googlePlaces.AutocompleteService();

      this.populateRecentSearches();
      this.populateRecentAddresses();

      this.initHandlers();
    }

    static getRecentSearches() {
      return ls.getItem(RECENT_SEARCH_LABEL) ? JSON.parse(ls.getItem(RECENT_SEARCH_LABEL)) : [];
    }

    static setRecentSearches(value) {
      ls.setItem(RECENT_SEARCH_LABEL, JSON.stringify(value));
    }

    static getRecentLocations() {
      return ls.getItem(RECENT_ADDRESS_LABEL) ? JSON.parse(ls.getItem(RECENT_ADDRESS_LABEL)) : [];
    }

    static setRecentLocations(value) {
      ls.setItem(RECENT_ADDRESS_LABEL, JSON.stringify(value));
    }

    populateRecentSearches() {
      const template = this.recentSearchesContainer.querySelector('.fake-item');
      const fragment = doc.createDocumentFragment();
      SearchWidget.getRecentSearches()
        .forEach((searchItem) => {
          const domNode = template.cloneNode(true);
          domNode.classList.remove('d-none');
          domNode.querySelector('.item-text').innerText = searchItem;
          fragment.appendChild(domNode);
        });
      if (fragment.childElementCount > 0) {
        this.recentSearchesContainer.classList.remove('d-none');
        this.recentSearchesContainer.appendChild(fragment);
      }
    }

    populateRecentAddresses() {
      const template = this.recentAddressesContainer.querySelector('.fake-item');
      const fragment = doc.createDocumentFragment();
      SearchWidget.getRecentLocations()
        .forEach((address) => {
          const domNode = template.cloneNode(true);
          domNode.classList.remove('d-none');
          domNode.querySelector('.item-text').innerText = address;
          fragment.appendChild(domNode);
        });
      if (fragment.childElementCount > 0) {
        this.recentAddressesContainer.classList.remove('d-none');
        this.recentAddressesContainer.appendChild(fragment);
      }
    }

    initHandlers() {
      this.searchAddress.addEventListener('keypress', this.onAddressChange.bind(this));
      this.optionForm
        .querySelectorAll('.search-dropdown .recent-search-item')
        .forEach(item => item.addEventListener('click', this.onSearchTextClick.bind(this)));

      this.optionForm
        .querySelectorAll('.search-dropdown .search-category')
        .forEach(item => item.addEventListener('click', this.onSearchCategoryClick.bind(this)));

      this.recentAddressesContainer.querySelectorAll('.recent-search-item')
        .forEach(item => item.addEventListener('click', this.onAutoCompleteClick.bind(this)));

      this.optionForm.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    onSearchTextClick(event) {
      event.preventDefault();
      // Set input value to selected AutoComplete option.
      this.searchInput.value = event.currentTarget.querySelector('.item-text').innerText;
    }

    onSearchCategoryClick(event) {
      event.preventDefault();

      this.searchCategory.value = event.currentTarget.querySelector('.item-text').innerText;
      this.searchCategoryIcon.className = `${event.currentTarget.querySelector('span[class^=wm_icon-]').className} mr-2`;
    }

    onAutoCompleteClick(event) {
      event.preventDefault();
      // Set input value to selected AutoComplete option.
      this.searchAddress.value = event.currentTarget.querySelector('.item-text').innerText;
    }

    /**
         * Submit form handler. Updates recent searches
         * list and recent addresses list in local storage.
         * @private
         */
    onFormSubmit() {
      const searchQuery = this.searchInput.value.trim();
      if (searchQuery) {
        let recentSearches = SearchWidget.getRecentSearches();
        recentSearches.unshift(searchQuery);
        recentSearches = Array.from(new Set(recentSearches));
        if (recentSearches.length > MAX_RECENT_SEARCHES) {
          recentSearches.splice(-1, 1);
        }
        SearchWidget.setRecentSearches(recentSearches);
      }

      const searchAddress = this.searchAddress.value.trim();
      if (searchAddress) {
        let recentAddresses = SearchWidget.getRecentLocations();
        recentAddresses.unshift(searchAddress);
        // Get rid of duplicates.
        recentAddresses = Array.from(new Set(recentAddresses));
        if (recentAddresses.length > MAX_RECENT_ADDRESSES) {
          recentAddresses.splice(-1, 1);
        }
        SearchWidget.setRecentLocations(recentAddresses);
      }
    }

    onAddressChange(event) {
      if ((event.keyCode < 48 && event.keyCode !== 8)
        || event.metaKey || event.altKey || event.ctrlKey) {
        return;
      }
      const value = event.target.value + (event.keyCode >= 48 ? event.key : '');
      const autoCompleteRequest = {
        input: value,
      };
      this.autocompleteService.getPlacePredictions(autoCompleteRequest, (data, status) => {
        this.addressAutocompleteContainer.innerHTML = '';
        if (status === googlePlaces.PlacesServiceStatus.OK) {
          const fragment = doc.createDocumentFragment();
          for (let i = 0, dataCount = data.length; i < dataCount; i += 1) {
            const item = this.addressAutocomplete.cloneNode(true);
            item.classList.remove('d-none');
            item.classList.add('d-flex');
            item.addEventListener('click', this.onAutoCompleteClick.bind(this));

            const span = item.querySelector('span');
            span.innerText = data[i].description;

            fragment.appendChild(item);
          }
          this.addressAutocompleteContainer.appendChild(fragment);
        }
      });
    }
  }

  $(doc).ready(() => {
    const searchForm = doc.getElementById('search-form');
    if (searchForm) {
      const searchWidget = new SearchWidget(searchForm);
      searchWidget.init();
    }
  });
})(window);
